import { useEffect, useState } from "react";
import { Chat } from "stream-chat-react";
import "stream-chat-react/dist/css/v2/index.css";
import "./chat.scss";
import { StreamChat } from "stream-chat";
import { useAppDispatch, useAppSelector } from "../../hooks/store-hooks";
import RightPanel from "./right-panel";
import LeftPanel from "./left-panel";
import { setChatClient } from "../../store/slices/chatSlice";
import { MODAL_NAME } from "../../constants";
import GroupChat from "./group-chat";
import {
  getAllChattedChannel,
  getAllTeamChannelWithoutJoin,
} from "../../store/actions/chatActions";
import { toastSuccess } from "../toast";

const ChatContainer = ({
  otherUserData,
  isRightPanelHide = false,
  setMessageLoading,
}: any) => {
  const [isShowRightPanel, setIsShowRightPanel] = useState(false);
  const [isShowLeftPanel, setIsShowLeftPanel] = useState(false);
  const [isShowLeftPanelfull, setIsShowLeftPanelfull] = useState(false);
  const [channel, setChannel] = useState<any>(null);
  const [selectedUserData, setSelectedUserData]: any = useState(otherUserData);
  const [joinChannelIsLoading, setjoinChannelIsLoading] = useState(false);

  const dispatch = useAppDispatch();

  const { homeData } = useAppSelector((state) => state.home || {});
  const { user: userData } = homeData || {};

  const { modalName } = useAppSelector((state: any) => state.modal ?? {});

  const { _id: userChatId } = userData || {};
  const { key: streamApiKey, chat_token: chatToken } = userData?.stream || {};

  let chatClient: any;

  if (userChatId && streamApiKey && chatToken) {
    chatClient = StreamChat.getInstance(streamApiKey);
    if (chatClient.user === undefined)
      chatClient.setUser(
        {
          id: userChatId,
        },
        chatToken,
      );
  }

  useEffect(() => {
    if (chatClient) {
      dispatch(setChatClient(chatClient));
    }
  }, [chatClient]);

  const initChannel = async () => {
    const otherUserId = selectedUserData?.user?.id;

    let newChannel;
    if (
      selectedUserData?.user?.type === "team" ||
      selectedUserData?.user?.type === "adminOnly"
    ) {
      newChannel = chatClient.channel(
        selectedUserData?.user?.type,
        selectedUserData?.user?.id,
      );
    } else if (selectedUserData?.type === "messaging") {
      newChannel = chatClient.channel("messaging", {
        members: [userChatId, otherUserId],
      });
    }
    if (newChannel) {
      await newChannel.watch();
      setChannel(newChannel);
    }
  };

  useEffect(() => {
    if (channel) {
      if (setMessageLoading) setMessageLoading(false);
      setIsShowLeftPanel(true);
      setIsShowLeftPanelfull(true);
    }
  }, [channel]);

  useEffect(() => {
    setSelectedUserData(otherUserData);
  }, [otherUserData]);

  useEffect(() => {
    if (selectedUserData?.user?.id) {
      initChannel();
    }
  }, [selectedUserData]);

  const onSelectUser = (selectedUser: any) => {
    setSelectedUserData(selectedUser);
  };

  const handleLeftPanelWithList = () => {
    if (isRightPanelHide) {
      hideLeftPanel();
      return;
    }
    setIsShowLeftPanel(true);
    setIsShowLeftPanelfull(true);
    setChannel(null);
  };

  const hideLeftPanel = () => {
    setIsShowLeftPanel(false);
    setIsShowLeftPanelfull(false);
    setChannel(null);
  };

  const handleWhenSelectDataAndOpenLeftPanel = (selectedUser: any) => {
    setSelectedUserData(selectedUser);
    setIsShowLeftPanel(true);
    setIsShowLeftPanelfull(true);
  };

  const handelJoinChannel = async (channelId: string, channelType: string) => {
    if (chatClient) {
      setjoinChannelIsLoading(true);
      const teamChannel = await chatClient.channel(channelType, channelId);
      if (teamChannel) {
        const response = await channel.addMembers([userChatId]);

        if (response?.channel?.id) {
          toastSuccess({ message: "Channel Joined Successfully" });
          dispatch(getAllTeamChannelWithoutJoin({ chatClient, userChatId }));
          dispatch(
            getAllChattedChannel({ chatClient, userChatId, type: "team" }),
          );
          setSelectedUserData({
            type: channel.type,
            user: response.channel?.data,
            is_joined: true,
          });
        }
      }
      setjoinChannelIsLoading(false);
    }
  };
  if (!chatClient) {
    return (
      <>
        <div className="chat-main-container">
          <aside className="chat-inner-container">
            {!isRightPanelHide ? (
              <div
                className={`chat-list-container chat-list-container-right shadow-lg ${
                  !isShowRightPanel ? "chat-list-container-minimized" : ""
                }`}
              >
                <RightPanel
                  isShowRightPanel={isShowRightPanel}
                  setIsShowRightPanel={setIsShowRightPanel}
                  isShowLeftPanel={isShowLeftPanel}
                  setIsShowLeftPanel={setIsShowLeftPanel}
                  setSelectedUserData={setSelectedUserData}
                  selectedUserData={selectedUserData}
                  setIsShowLeftPanelfull={setIsShowLeftPanelfull}
                  handleLeftPanelWithList={handleLeftPanelWithList}
                />
              </div>
            ) : null}
          </aside>
        </div>
        {modalName === MODAL_NAME.GROUP_CHAT ? (
          <GroupChat
            chatClient={chatClient}
            handleWhenSelectDataAndOpenLeftPanel={
              handleWhenSelectDataAndOpenLeftPanel
            }
          />
        ) : null}
      </>
    );
  }

  return (
    <>
      <div className="chat-main-container">
        <aside className="chat-inner-container">
          <Chat client={chatClient} theme="messaging light">
            {!isRightPanelHide ? (
              <div
                className={`chat-list-container chat-list-container-right shadow-lg ${
                  !isShowRightPanel ? "chat-list-container-minimized" : ""
                }`}
              >
                <RightPanel
                  handleWhenSelectDataAndOpenLeftPanel={
                    handleWhenSelectDataAndOpenLeftPanel
                  }
                  isShowRightPanel={isShowRightPanel}
                  setIsShowRightPanel={setIsShowRightPanel}
                  isShowLeftPanel={isShowLeftPanel}
                  setIsShowLeftPanel={setIsShowLeftPanel}
                  setSelectedUserData={setSelectedUserData}
                  selectedUserData={selectedUserData}
                  setIsShowLeftPanelfull={setIsShowLeftPanelfull}
                  handleLeftPanelWithList={handleLeftPanelWithList}
                />
              </div>
            ) : null}
            {isShowLeftPanel ? (
              <div
                className={`chat-list-container message-container shadow-lg ${
                  !isShowLeftPanelfull ? "chat-list-container-minimized" : ""
                }`}
              >
                <LeftPanel
                  chatClient={chatClient}
                  handleLeftPanelWithList={handleLeftPanelWithList}
                  channel={channel}
                  selectedUserData={selectedUserData}
                  onSelectUser={onSelectUser}
                  hideLeftPanel={hideLeftPanel}
                  handelJoinChannel={handelJoinChannel}
                  joinChannelIsLoading={joinChannelIsLoading}
                />
              </div>
            ) : null}
          </Chat>
        </aside>
      </div>
      {modalName === MODAL_NAME.GROUP_CHAT ? (
        <GroupChat
          chatClient={chatClient}
          handleWhenSelectDataAndOpenLeftPanel={
            handleWhenSelectDataAndOpenLeftPanel
          }
        />
      ) : null}
    </>
  );
};

export default ChatContainer;
